import React from "react";
import "./App.css";

import Header from "./component/Header";
import Footer from "./component/Footer";

import { Route, Routes, useLocation } from "react-router-dom";

import Home from "./component/Home";
import Login from "./Pages/Login";

import Dashboard from "./Pages/Dashboard";
import School from "./admin/School";
import ParentList from "./admin/ParentList";
import ParentRegister from "./Parent/ParentRegister";
import ParentLogin from "./Parent/ParentLogin";
import ForgotPassword from "./Parent/ForgotPassword";
import VerifyOtp from "./Parent/VerifyOtp";
import DashboardHome from "./admin/DashboardHome";
import ChangeSchool from "./Parent/ChangeSchool";
import OldParentData from "./admin/OldParentData";
import ParentUniform from "./Parent/ParentUniform";
import AddUniform from "./admin/AddUniform";
import UniformDetail from "./Parent/UniformDetail";
import CartPage from "./Parent/CartPage";
import Orders from "./admin/Orders";
import ParentOrderDetails from "./admin/ParentOrderDetails";
import CategoryPage from "./Parent/CategoryPage";
import CheckoutPage from "./Parent/CheckoutPage";
import PrivateRoute from "./Pages/PrivateRoute";
import ProductDetails from "./admin/ProductDetails";
import OrderDetails from "./admin/OrderDetails";
import OrderHistory from "./Parent/OrderHistory";
import TrackOrder from "./Parent/TrackOrder";
import FAQ from "./component/FAQ";
import TermsofService from "./component/TermsofService";
import Return from "./component/Return";
import Contact from "./component/Contact";
import PrivacyPolicy from "./component/PrivacyPolicy";
import AdminProfile from "./admin/AdminProfile";
import SchoolUniformDetail from "./admin/AddUniform";
import SchoolOrders from "./admin/SchoolOrders";
import ForgetPass from "./Pages/ForgotPass";
import VerifyadOtp from "./Pages/VerifyadOtp";
import ResetPassword from "./Pages/ResetPassword";
import TotalRevenue from "./admin/TotalRevenue";
import ManageStaff from "./admin/ManageStaff";
import ManageTeam from "./admin/ManageTeam";



function App() {
  const location = useLocation();

  return (
    <div>
      {/* Hide Header on Dashboard */}
      {!location.pathname.startsWith("/dashboard") && <Header />}

      <Routes>
        {/* ================= HOME ================= */}
        <Route path="/" element={<Home />} />
        <Route path="/help-center" element={<FAQ />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/termsofservice" element={<TermsofService />} />
        <Route path="/return" element={<Return/>} />
        <Route path="/contact" element={<Contact />} />


        {/* ================= AUTH ================= */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgetpas" element={<ForgetPass/>}/>
        <Route path="/verify-otp" element={<VerifyadOtp/>}/>
        <Route path="/reset-password" element={<ResetPassword />}/>

        <Route path="/parent/register" element={<ParentRegister />} />
        <Route path="/manage-team" element={<ManageStaff />} />
        <Route path="/parent/login" element={<ParentLogin />} />
        <Route path="/parent/verify" element={<VerifyOtp />} />
        <Route path="/parent/forgot" element={<ForgotPassword />} />
        <Route path="/parent/change-school" element={<ChangeSchool />} />
        

        {/* ================= PARENT PROTECTED ================= */}
        <Route
          path="/parent/uniform"
          element={
            <PrivateRoute role="parent">
              <ParentUniform />
            </PrivateRoute> }
        />

        <Route
          path="/parent/cart"
          element={
            <PrivateRoute role="parent">
              <CartPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/checkout"
          element={
            <PrivateRoute role="parent">
              <CheckoutPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/parent/orders"
          element={
            <PrivateRoute role="parent">
              <OrderHistory />
            </PrivateRoute>
          }
        />

        <Route
          path="/uniform/:id"
          element={
            <PrivateRoute role="parent">
              <UniformDetail />
            </PrivateRoute>
          }
        />

        <Route
          path="/track-order/:orderId"
          element={
            <PrivateRoute role="parent">
              <TrackOrder />
            </PrivateRoute>
          }
        />

        <Route
          path="/category/:category"
          element={
            <PrivateRoute role="parent">
              <CategoryPage />
            </PrivateRoute>
          }
        />

        {/* ================= ADMIN DASHBOARD ================= */}

        <Route
          path="/dashboard"
          element={
            <PrivateRoute role="admin">
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route index element={<DashboardHome />} />
          <Route path="schools" element={<School />} />
          <Route path="school-details/:schoolId" element={<SchoolUniformDetail />} />
          <Route path="profile" element={<AdminProfile />} />
          <Route path="parents" element={<ParentList />} />
          <Route path="parents/history" element={<OldParentData />} />
          
          {/* ✅ FIXED PATH: dashboard ke andar nested hai isliye direct name likhein */}
          <Route path="total-revenue" element={<TotalRevenue />} />
          
          <Route path="uniforms" element={<AddUniform />} />
          <Route path="uniforms/:schoolId" element={<AddUniform />} />
          <Route path="orders" element={<Orders />} />
          <Route path="order/:parentId" element={<ParentOrderDetails />} />
          <Route path="product-detail" element={<ProductDetails />} />
          <Route path="order-details/:id" element={<OrderDetails />} />
          <Route path="school-orders/:schoolId" element={<SchoolOrders />} />
          <Route path="manage-team" element={<ManageTeam />} />
          
        </Route>
      </Routes>

      {/* Hide Footer on Dashboard */}
      {!location.pathname.startsWith("/dashboard") &&
        !location.pathname.startsWith("/parent") && <Footer />}
    </div>
  );
}

export default App;